import { IProduktdefinition } from "./IProduktdefinition";
import { ProduktdefinitionMatrisdata } from "./ProduktdefinitionMatrisdata";

export class ProduktdefinitionStolpdata {
    matpunktOverStubbe: number;

    constructor(private readonly model: IProduktdefinition, readonly matrisdata: ProduktdefinitionMatrisdata) {
        this.matpunktOverStubbe = this.model.matpunktOverStubbe;
    }

    mapToDto(model: IProduktdefinition) {
        model.matpunktOverStubbe = this.matpunktOverStubbe;
    }
}
